const initialiseFiltersFromConfig = (configFilters) =>
  configFilters.map((filter) => ({
    ...filter,
    isSelected: false,
    subInformation: filter.subInformation
      ? filter.subInformation.map((subFilter) => ({ ...subFilter, isSelected: false }))
      : [],
  }));

const filterItemByDiet = (item, veganFilter, vegetarianFilter) => {
  const veganItem = (item.vegan || item.vegan === null) && item;
  const vegetarianItem = (item.vegetarian || item.vegetarian === null) && item;

  if (veganFilter) {
    return veganItem;
  }

  if (vegetarianFilter) {
    return vegetarianItem;
  }

  return item;
};

const hasAllergen = (allergen, subFilters) => {
  if (allergen === true) return true;

  if (typeof allergen === 'object') {
    return subFilters.some((subFilter) => allergen[subFilter.value] === true);
  }

  return false;
};

const filterItem = (
  item,
  selectedAllergenFilters,
  selectedChildAllergenFilters,
  veganFilter,
  vegetarianFilter,
  potentialAllergensFilter
) => {
  const itemHasAllergen = (): boolean =>
    selectedAllergenFilters.some((filter) => {
      const allergen = item.allergens?.[filter.value];
      const potentialAllergen = potentialAllergensFilter && item.potentialAllergens?.[filter.value];

      if (
        hasAllergen(allergen, selectedChildAllergenFilters.flat()) ||
        hasAllergen(potentialAllergen, selectedChildAllergenFilters.flat())
      ) {
        return true;
      }

      return selectedChildAllergenFilters.some((childFilters) =>
        childFilters.some(
          (subFilter) =>
            allergen?.[subFilter.value] === true || potentialAllergen?.[subFilter.value] === true
        )
      );
    });

  const filteredItem = filterItemByDiet(item, veganFilter, vegetarianFilter);

  return !itemHasAllergen() && filteredItem;
};

const filterItems = (
  items,
  selectedAllergenFilters,
  selectedChildAllergenFilters,
  veganFilter,
  vegetarianFilter,
  potentialAllergensFilter
) => {
  const hasNoAllergenFilters =
    !selectedAllergenFilters?.length && !selectedChildAllergenFilters?.length;

  return items.filter((item) => {
    if (item?.setMenu) {
      return true;
    }

    if (hasNoAllergenFilters) {
      return filterItemByDiet(item, veganFilter, vegetarianFilter);
    }

    return filterItem(
      item,
      selectedAllergenFilters,
      selectedChildAllergenFilters,
      veganFilter,
      vegetarianFilter,
      potentialAllergensFilter
    );
  });
};

const formatItemForAllergenLabels = (item) => {
  const { items, selectedAllergens } = item;

  const selectedAllergensToFormat = item?.isSetMenu
    ? items[0].selectedAllergens
    : selectedAllergens;

  return selectedAllergensToFormat.map((selectedAllergen) => selectedAllergen.label);
};

const flattenAllergens = (allergens?: GatsbyTypes.listOfAllergens): string[] => {
  if (!allergens) {
    return [];
  }

  return Object.entries(allergens).reduce((acc: string[], [key, val]) => {
    if (val === true) {
      acc.push(key);
    }

    if (!val) {
      return acc;
    }

    const subAllergens = Object.entries(val);

    if (subAllergens.length) {
      subAllergens.forEach(([k, v]) => {
        if (v) {
          acc.push(k);
        }
      });
    }

    return acc;
  }, []);
};

export {
  filterItem,
  filterItems,
  filterItemByDiet,
  flattenAllergens,
  formatItemForAllergenLabels,
  initialiseFiltersFromConfig,
};
